// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyJobsList_container__HRHj_","title":"EmptyJobsList_title__8TLM2","description":"EmptyJobsList_description__RKeDH","emoji":"EmptyJobsList_emoji__qJ8_V"};